import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAllCategoriesThunk, setCategoryRefresh } from '../../redux/category/getAllCategorySlice';
import api from '../../utils/api';
import MasterHeader from '../../component/reusable/MasterHeader';
import AllAdminUsersTable from '../../component/adminComps/AllAdminUsersTable';
import { getAdminThunk, getAllAdminThunk, setAdminPage } from '../../redux/admin/adminSlice';
import UserHeader from '../../component/reusable/UserHeader';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';



const AllAdminUsers = () => {

  const [statuss, setStatus] = useState("");
  const [search, setSearch] = useState('')
  const [limit, setLimit] = useState(10)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [sortBy, setSortyBy] = useState('createdAt');
  const [order, setOrder] = useState('asc')

  const { admindata, loading, error, refresh,exportLoading,page } = useSelector((state) => state.admin);
  const admins = admindata?.data
  const totalPages = admindata?.totalPages
  const totalItems = admindata?.totalItems
  const itemsPerPage = admindata?.limit


  // calculate start & end of items -------------------
  const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;




  useEffect(() => {
    dispatch(getAdminThunk(`?search=${search}&page=${page}&status=${statuss}&limit=${limit}&sortBy=${sortBy}&order=${order}`));
  }, [page, search, statuss, limit, refresh,sortBy,order]);


  const exportData = async () => {
    const data = await dispatch(getAllAdminThunk())

    if (data?.payload?.success === true) {
      const adminsdata = data?.payload?.data
      const exportdata = adminsdata?.map((item) => ({
        'name': item?.name || '-',
        'phone':item?.phone || '-',
        
        'createdAt': fomateDate(item?.createdAt),
      }))
      exportDataExcel(exportdata, "adminuser")
    }
  }


  const handleOpenMenu = (sort) => {
    setSortyBy(sort)
    setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
};

  return (
    <div>
       <MasterHeader
        index="Admin users"
        root="Dashboard"
        setStatus={setStatus}
        setSearch={setSearch}
        onClickadd={() => navigate('/admin/addAdmin')}
        buttonText={'Add User'}
        exportData={exportData}
        exportLoading={exportLoading}
        hideBulk={'hide'}
      />
      {loading ?
        <div>
          Please wait...
        </div>
        :
        <>
          {
            admins?.length > 0 ?
              <AllAdminUsersTable
                admins={admins}
                page={page}
                setPage={setAdminPage}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                totalPages={totalPages}
                start={start}
                end={end}
                handleOpenMenu={handleOpenMenu}
              />
              :
              <div>
                No categories found
              </div>

          }
        </>
      }
    </div>
  );
};

export default AllAdminUsers;
